// Language selector (i18n.md). The language is resolved server-side (the
// lang user setting > the genus-lang cookie), so switching = persist +
// reload; the server then renders the page in the new language (chrome +
// the g.translate dictionary). Logged-in users get the choice SAVED as
// the `lang` user setting (rides the session context, follows them to
// any device); the cookie is set either way — it covers anonymous
// visitors and the pre-login flow. genus itself never reads the cookie -
// the app owns where the language comes from (a URL prefix on the public
// frontend, this mechanism in the admin).
// Three render sites, one mechanism: [data-lang-select] (a <select> — the
// user menu's picker and any project chrome including partials/
// language-select.latte: a change switches), [data-lang-option] (the
// same partial's dropdown items: a click switches) and .auth-lang (the auth
// shell's centered row under the card — the pre-login pick that must
// survive into the session: a click switches).
function switchLanguage(code, el) {
	if (!code || code === document.documentElement.getAttribute('lang')) return;
	const switchTo = async () => {
		document.cookie = 'genus-lang=' + encodeURIComponent(code) + ';path=/;max-age=31536000;samesite=lax';
		if (window.g && window.g.user && window.g.fetch) {
			// best-effort — the cookie already carries the switch
			try { await window.g.fetch('/frm/user/profile/save', { lang: code }, { progress: false }); } catch (e) { /* offline/anonymous: cookie wins */ }
		}
		location.reload();
	};
	// g.action, one key for every entry: a second pick while the first
	// saves is a no-op; navigate keeps the entry busy until the reload lands
	return window.g && window.g.action ? window.g.action(el, switchTo, { navigate: true, key: 'language-switch' }) : switchTo();
}

export function initLanguage() {
	document.querySelectorAll('.auth-lang').forEach((item) => {
		item.addEventListener('click', (e) => switchLanguage(item.getAttribute('data-lang'), e.currentTarget));
	});
	// delegated: a picker rendered later (a drawer, an offcanvas) works too
	document.addEventListener('change', (e) => {
		const select = e.target instanceof Element ? e.target.closest('select[data-lang-select]') : null;
		if (select) switchLanguage(select.value, select);
	});
	// the dropdown presentation: a click on an item naming a language
	document.addEventListener('click', (e) => {
		const option = e.target instanceof Element ? e.target.closest('[data-lang-option]') : null;
		if (option) switchLanguage(option.getAttribute('data-lang-option'), option);
	});
}
